// Yönlendirme yardımcıları: tembel ekran yükleme + izin/bayrak koruması (her alan kendi routes.tsx'inde kullanır).
import { lazy, Suspense, type ComponentType, type LazyExoticComponent } from 'react';
import type { Action, Module, PermissionModule } from '@serota/domain';
import { SkeletonCards } from '@serota/ui-web';
import { RequirePerm } from '../../components/Guard';

export type LazyPage = LazyExoticComponent<ComponentType>;

/** `load(() => import('./X'), 'X')` — adlandırılmış dışa aktarımı tembel bileşene çevirir. */
export const load = <K extends string>(f: () => Promise<Record<K, ComponentType>>, name: K): LazyPage =>
  lazy(() => f().then((m) => ({ default: m[name] })));

/** Ekranı modül izni (+ varsa özellik bayrağı) ile korur; bayrak kapalıysa ekran hiç açılmaz. */
export function guard(Comp: LazyPage, perm: PermissionModule, opts: { action?: Action; flag?: Module } = {}) {
  return (
    <RequirePerm perm={perm} action={opts.action} flag={opts.flag}>
      <Suspense
        fallback={
          <div className="sr-page">
            <SkeletonCards count={3} height={120} />
          </div>
        }
      >
        <Comp />
      </Suspense>
    </RequirePerm>
  );
}
